<template>
    <div>
        <div class="kgr-row kgr-row--extraSmallMargin">
            {{ $t('offering.image.uploadHint1') }}<br />
            {{ $t('offering.image.uploadHint2') }}
        </div>
        <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--center kgr-row kgr-row--smallMargin">
            <div
                v-if="hasImage"
                class="kgr-postfix__fixed"
            >
                <img
                    :src="imageUrl"
                    :alt="offering.title"
                    class="image"
                />
            </div>
            <div class="kgr-postfix__fluid">
                <template v-if="image">
                    <kgr-button
                        :value="$t('offering.image.upload')"
                        :pending="pendingUpload"
                        small
                        type="blue"
                        @click="uploadImage"
                    />
                </template>
                <template v-else-if="imageUrl">
                    <a
                        class="kgr-button kgr-button--small kgr-button--danger"
                        @click="deleteImage()"
                    >{{ $t('offering.image.delete') }}</a>
                </template>
            </div>
        </div>
        <kgr-drop-file
            ref="dropFile"
            jpg-png-only
            @change="change"
            @removeFile="resetError"
        />
        <div v-show="error.forField('file')" class="error">
            {{ error.messageForField('file') }}
        </div>
    </div>
</template>

<script>
import DropFile from '../common/form/input/DropFile.vue';
import Error from '../../js/model/Error.js';
import KgrButton from '../common/form/button/KgrButton.vue';
import Offering from '../../js/dto/offering/Offering.js';
import OfferingRepository from '../../js/repository/club/offering/OfferingRepository.js';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-drop-file': DropFile,
    },
    props: {
        offering: {
            type: Offering,
            required: false,
        },
    },
    data() {
        return {
            image: null,
            error: new Error(),
            pendingUpload: false,
            imageUrl: null,
        };
    },
    computed: {
        hasImage() {
            return this.imageUrl;
        },
    },
    created() {
        this.imageUrl = this.offering.imageUrl;
    },
    methods: {
        change(image) {
            this.image = image;
        },
        uploadImage() {
            if (this.image) {
                this.pendingUpload = true;
                OfferingRepository.uploadImage(this.offering.id, this.image)
                    .then(() => {
                        this.error = new Error();
                        this.image = null;
                        this.$forceUpdate();
                        this.$refs.dropFile.resetFiles();
                        this.refreshImageUrl();
                        this.$notify.success('offering.image.upload.success');
                    })
                    .catch((error) => {
                        this.error = error;
                        this.$notify.error('offering.image.upload.failed');
                    })
                    .finally(() => this.pendingUpload = false);
            }
            return null;
        },
        deleteImage() {
            showConfirm(this.$t('confirmInformal'), this.$t('offering.image.delete.confirm'), () => {
                OfferingRepository.removeImage(this.offering.id)
                    .then(() => {
                        this.error = new Error();
                        this.imageUrl = null;
                        this.$forceUpdate();
                        this.$notify.success('offering.image.delete.success');
                    })
                    .catch((error) => {
                        this.error = error;
                        this.$notify.error('offering.image.delete.failed');
                    });
            }, 'Ok');
        },
        refreshImageUrl() {
            OfferingRepository.getImageUrl(this.offering.id)
                .then((imageUrl) => this.imageUrl = imageUrl)
                .catch((error) => this.error = error);
        },
        resetError() {
            this.error = new Error();
        },
    },
};
</script>

<style scoped lang="scss">
.image {
    max-width: 144px;
    max-height: 90px;
}
.error {
    margin-top: 10px;
    color: #fe0000;
}
</style>
